import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Typography, Icon } from "@material-ui/core";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { useVariableData } from "@ploy-lib/calculation";
import { FormattedMessage, injectIntl } from "react-intl";
import { useAppLoad } from "../../appLoadContext";
import { ApplicationStatus } from "@ploy-lib/types";
const useStyles = makeStyles(theme => ({
    fullWidth: {
        width: "100%"
    },
    card: {
        backgroundColor: "#fff",
        borderRadius: 8,
        paddingTop: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 16,
        [theme.breakpoints.down("sm")]: {
            paddingTop: 8,
            paddingLeft: 0,
            paddingRight: 0
        }
    },
    svgStyle: {
        width: "48px",
        height: "48px",
        marginLeft: 8
    },
    verticalAlignCenter: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        aligntItems: "center"
    },
    headerStyle: {
        paddingLeft: 24,
        [theme.breakpoints.down("sm")]: {
            fontSize: "1em",
            paddingLeft: 48
        }
    },
    salesText: {
        fontSize: "0.9rem",
        lineHeight: "16px",
        whiteSpace: "pre-line"
    },
    fontWeightBold: {
        fontWeight: 700
    },
    insurancePriceText: {
        fontWeight: "bold",
        fontSize: "150%"
    }
}));
addRegisteredSectionLayout({
    name: "PaymentInsuranceSection",
    displayName: "PaymentInsuranceSection",
    settings: {}
});
const PaymentInsuranceSection = injectIntl((props) => {
    const { className, onClick } = props;
    const classes = useStyles();
    const { applicationStatus, settings } = useAppLoad();
    const paymentInsurancePdfUrl = (settings &&
        settings.distributionValues["distributionPaymentInsurancePdfUrl"]) ||
        "";
    let { value: price = 0 } = useVariableData("Calculator", "EP_TermAmount_PAYMENT_INSURANCE");
    const appIsApproved = applicationStatus === ApplicationStatus.ManuallyApproved ||
        applicationStatus === ApplicationStatus.AutoApproved ||
        applicationStatus === ApplicationStatus.ApprovedWithConditions;
    // Temp handling of rounding decimal numbers, needs to be clarified with ASF:
    if (price > 0) {
        price = Math.round(price);
    }
    // Hide PaymentInsuranceSection if application is not approved:
    return appIsApproved ? (_jsxs(Grid, { container: true, spacing: 2, className: clsx(className, classes.card), onClick: onClick, children: [_jsxs(Grid, { container: true, children: [_jsx(Grid, { item: true, xs: 1, className: classes.verticalAlignCenter, children: _jsx(Icon, { className: clsx(classes.svgStyle, "far fa-smile"), color: "secondary" }) }), _jsx(Grid, { item: true, xs: 11, className: clsx(classes.verticalAlignCenter, classes.headerStyle), children: _jsx("h2", { children: _jsx(FormattedMessage, { id: "template-form.sections.payment-insurance.header-text", defaultMessage: "A safer payment experience" }) }) })] }), _jsx(Grid, { item: true, xs: 12, children: _jsx(Typography, { className: classes.salesText, children: _jsx(FormattedMessage, { id: "template-form.sections.payment-insurance.description-text", defaultMessage: "payment-insurance.description" }) }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(Typography, { className: classes.fontWeightBold, children: _jsx(FormattedMessage, { id: "template-form.sections.payment-insurance.info-text", defaultMessage: "You can easily order payment insurance when you sign the loan documents." }) }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx("a", { href: paymentInsurancePdfUrl, target: "_blank", rel: "noopener noreferrer", children: _jsx(Typography, { children: _jsx(FormattedMessage, { id: "template-form.sections.payment-insurance.info-link", defaultMessage: "Read more about our insurance" }) }) }) }), price > 0 && (_jsx(Grid, { item: true, xs: 12, container: true, spacing: 2, children: _jsx(Grid, { item: true, xs: 4, className: classes.verticalAlignCenter, children: _jsx(Typography, { className: classes.insurancePriceText, children: _jsx(FormattedMessage, { id: "template-form.sections.payment-insurance.insurance-cost", defaultMessage: "+ {insuranceCost, number, currency} per month", values: {
                                insuranceCost: price
                            } }) }) }) }))] })) : null;
});
PaymentInsuranceSection.displayName = "DployPaymentInsuranceSection";
export { PaymentInsuranceSection };
//# sourceMappingURL=PaymentInsuranceSection.js.map